<template>
  <div class="order-prep-export-button" v-tooltip="getExportTooltip">
    <v-btn
      small
      color="blue darken-2"
      outlined
      @click="exportCSV"
      :loading="exporting"
      :disabled="!selectedFilter"
      >Export to CSV</v-btn
    >
    <a ref="downloadLink" class="d-none" :href="linkHref">CSV Download Link</a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'

import Laravel from '@/services/Laravel'
import { format } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

export default {
  name: 'AdminOrderPrepCSVexportButton',
  components: {},
  data() {
    return {
      exporting: false,
      exportSuccess: false,
      linkHref: '',
    }
  },
  computed: {
    ...mapGetters('shop', ['getShopId']),
    ...mapFields('admin', [
      'prepAvailabilitySelections',
      'orderPrepSearchDate',
    ]),
    hasSelectedAvailabilities() {
      return this.prepAvailabilitySelections.length
    }, // hasSelectedAvailabilities
    selectedFilter() {
      return this.prepAvailabilitySelections.length || this.orderPrepSearchDate
    }, // selectedFilter
    getExportTooltip() {
      return !this.hasSelectedAvailabilities && !this.orderPrepSearchDate
        ? {
            content: `<div class="proxima--font">Select Filters First</div>`,
            html: true,
            placement: 'left',
            triggers: ['hover', 'click'],
          }
        : null
    }, // getExportTooltip
    exportRoute() {
      return this.orderPrepSearchDate ? 'prep-by-date' : 'prep'
    },
  },
  methods: {
    async exportCSV() {
      if (!this.selectedFilter) return
      this.exporting = true

      await this.resetExportParams()
      try {
        let params
        if (this.hasSelectedAvailabilities) {
          const availabilities = this.prepAvailabilitySelections.map(
            (availabilityModel) => availabilityModel.$id
          )
          params = { availabilities }
        } else if (this.orderPrepSearchDate) {
          params = { date: this.orderPrepSearchDate }
        }

        let { data: exportedCSV } = await Laravel.get(
          `/shops/${this.getShopId}/orders/${this.exportRoute}/export`,
          { params },
          { headers: { Accept: 'text/csv' } }
        )
        this.exportSuccess = true
        await this.setupDownloadLink(exportedCSV)
        await this.$refs.downloadLink.click()
      } catch (error) {
        this.error = error
      } finally {
        this.exporting = false
      }
    },
    resetExportParams() {
      this.exportSuccess = false
      this.linkHref = ''
      this.$refs.downloadLink.setAttribute('download', '')
    },
    setupDownloadLink(exportedCSV) {
      const blob = new Blob([exportedCSV])
      this.linkHref = window.URL.createObjectURL(blob)
      const date = format(Date.now(), TimeFormats.dateAndTimeForFiles)

      this.$refs.downloadLink.setAttribute(
        'download',
        `Order-Prep-Export_${date}.csv`
      )
    }, // setupDownloadLink
  },
}
</script>
